import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import { AuthService } from "../../services/auth.service";
import styles from "./ForgerPassword.module.scss";
import {
  forgetPasswordSchema,
  forgetPasswordType,
} from "./ForgetPassword.schema";

const authService = AuthService.getInstance();
const ForgetPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgetPasswordSchema),
  });

  const forgetPassword = async (data: forgetPasswordType) => {
    try {
      await authService.forgetPassword(data.email);
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  return (
    <div className={styles.forgetPassword}>
      <h2>Forget Password?</h2>
      <form
        onSubmit={handleSubmit(forgetPassword)}
        className={styles.forgetPassword__container}
      >
        <Input
          register={register}
          name="email"
          label={"Email"}
          type="text"
          errorMessage={errors.email?.message}
        />

        <Button label="Forget?" type="submit" fullWidth={true} />
      </form>
    </div>
  );
};
export default ForgetPassword;
